import { Constants } from "./constants";
import { GenericScreenController } from "./screens/generic-screen-controller";
import { IScreenController } from "./screens/screen-controller";
import { IScreenStatusCommand } from "./screen-status-command";
import { Screen3Controller } from "./screens/screen-3-controller";
import { Screen6Controller } from "./screens/screen-6-controller";
import { Screen7Controller } from "./screens/screen-7-controller";
import { Screen9Controller } from "./screens/screen-9-controller";
import { NavigationBarManager } from "./navigation-bar-manager";

/**
 * Class in charge of controlling the forms workflow behabior and the interaction
 * between the screens
 **/
export class TobaccoWorkflowManager {

    /** 
     *  Contains all the controllers for the workflow screens.
     **/
    screens: Array<IScreenController>;

    /**
     *  Contains the array index of the active screen. The one
     *  being displayed to the user.
     **/
    activeScreenIndex: number;

    /**
     * Manages the behaviour of the navigation bar
     */
    navigationBarManager: NavigationBarManager;

    headerCloseButton: any = $(".tobacco-cessation-header-wrapper button.tobacco-cessation-header-close");

    constructor() {
        this.loadScreens();
        this.initFormFlow();

        // Event when the user clicks in the close button for the modal window
        $("#tobacco-modal .modal-close").click(function (e) {
            e.preventDefault();
            $("#tobacco-modal").hide();
        });

        // hide close buttons on browser
        const closeBtns = document.querySelectorAll('[data-close-tobacco-app]');

        let displayMode = 'browser tab';

        if (window.matchMedia('(display-mode: standalone)').matches) {
            displayMode = 'standalone';
        }

        if (displayMode === 'browser tab') {
            closeBtns.forEach((btn: HTMLButtonElement) => {
                btn.style.display = 'none';
            });
        }

        window.matchMedia('(display-mode: standalone)')
            .addListener(event => {

                if (event.matches) {
                    closeBtns.forEach((btn: HTMLButtonElement) => {
                    btn.style.display = '';
                });
            } else {
                    closeBtns.forEach((btn: HTMLButtonElement) => {
                        btn.style.display = 'none';
                });
            }
        });
    }

    /**
     * Adds all the available screens of the flow to the
     * screens array.
     **/
    private loadScreens(): void {

        this.screens = new Array<IScreenController>();
        this.navigationBarManager = new NavigationBarManager(this.screens);

        // Screens should be pushed in same order as their index.
        // By default all screens are inactive in the flow.
        // Each screen should define who is the next screen to show.

        //The first screen is number three because the introduction was removed
        this.screens.push(new GenericScreenController(Constants.SCREEN_1,
            this.navigationBarManager,
            [{
                active: true,
                targetScreenIndex: Constants.SCREEN_3
            }],
            true,
            {
                showCloseApp: false,
                showExit: false,
                showNext: true,
                showPrevious: false,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_1
            }));

        this.screens.push(new Screen3Controller(Constants.SCREEN_3, this.navigationBarManager));

        this.screens.push(new Screen6Controller(Constants.SCREEN_6, this.navigationBarManager));
        this.screens.push(new Screen7Controller(Constants.SCREEN_7, this.navigationBarManager));

        this.screens.push(new Screen9Controller(Constants.SCREEN_9, this.navigationBarManager));

        this.screens.push(new GenericScreenController(Constants.SCREEN_11,
            this.navigationBarManager,
            [{
                active: true,
                targetScreenIndex: Constants.SCREEN_10
            }],
            false,
            {
                showCloseApp: false,
                showExit: false,
                showNext: true,
                showPrevious: true,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_3
            }));

        this.screens.push(new GenericScreenController(Constants.SCREEN_12,
            this.navigationBarManager,
            [{
                active: true,
                targetScreenIndex: Constants.SCREEN_10
            }],
            false,
            {
                showCloseApp: false,
                showExit: false,
                showNext: true,
                showPrevious: true,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_3
            }));

        this.screens.push(new GenericScreenController(Constants.SCREEN_10,
            this.navigationBarManager,
            [{
                active: true,
                targetScreenIndex: Constants.SCREEN_14
            }],
            false,
            {
                showCloseApp: false,
                showExit: false,
                showNext: true,
                showPrevious: true,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_3
            }));

        this.screens.push(new GenericScreenController(Constants.SCREEN_14,
            this.navigationBarManager,
            [],
            false, {
                showCloseApp: true,
                showExit: true,
                showNext: false,
                showPrevious: true,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_3
            }));

        this.screens.push(new GenericScreenController(Constants.SCREEN_15,
            this.navigationBarManager,
            [],
            false, {
                showCloseApp: true,
                showExit: true,
                showNext: false,
                showPrevious: true,
                showStartOver: false,
                progressBarGroupIndex: Constants.GROUP_INDEX_3
            }));

        // Initializes the custom events for all the screens
        this.screens.forEach(function (screen: IScreenController, index: number, array: IScreenController[]) {
            screen.initEvents();
        });
    }

    /**
     * Makes all the required initializations for the wizard
     **/
    private initFormFlow(): void {
        this.activeScreenIndex = 0;
        this.getActiveScreen().loadScreenInitialStatus();
        this.getActiveScreen().showScreen();
        this.navigationBarManager.ButtonNext.click(this.onNextClick.bind(this));
        this.navigationBarManager.ButtonPrev.click(this.onPrevClick.bind(this));
        this.navigationBarManager.ButtonExit.click(this.onExitClick.bind(this));
        this.navigationBarManager.ButtonStartOver.click(this.onExitClick.bind(this));
        this.navigationBarManager.ButtonCloseApp.click(this.onCloseAppClick.bind(this));
        this.headerCloseButton.click(this.onCloseAppClick.bind(this));

        this.navigationBarManager.updateNavigationBarStatus(this.activeScreenIndex, this.getActiveScreen().getNavigationBarStatus());
    }

    /**
     * Gets the current screen the user is seeing
     * 
     * @returns Active screen controller
     **/
    private getActiveScreen(): IScreenController {
        if (this.screens && this.screens.length > this.activeScreenIndex) {            
            return this.screens[this.activeScreenIndex];
        }
        else {
            return null;
        }
    }

    /**
     * Callback called when the user clicks on the button 'Next'
     **/
    private onNextClick(e): boolean {        
        let activeScreen = this.getActiveScreen();

        // Before doing anything validates the screen if the
        // validation does not pass we don't move forward
        // Each screen has its own validations.
        // Ex.Required question.
        if (!activeScreen.validateScreen())
            return false;

        // Validate if this is the last screen, in that case
        // we don't move forward.
        if (this.activeScreenIndex + 1 >= this.screens.length)
            return false;

        // Request the current screen to calculate what is the
        // next screen that should be displayed to the user
        // this calculation is made by each screen based on its own
        // rules.
        let screenStatusCommands = activeScreen.calculateNextScreensInFlow();

        if (screenStatusCommands && screenStatusCommands.length > 0) {

            // Clear all the following screens starting form the current
            // screen, in case the user changes answer the flow is restarted.
            this.resetFollowingScreensStatus();

            // Updates the status of the next screens based on the
            // the current screen commands.
            this.updateScreensStatusInFlow(screenStatusCommands);
        }

        // Moves to the next screen
        this.goToNextActiveScreen();

        // Prevents to fire the default action of the button
        return false;

    }

    /**
     * Disables from the flow all the screens that follows the current active screen
     **/
    private resetFollowingScreensStatus(): void {
        for (var i = this.activeScreenIndex + 1; i < this.screens.length; i++) {
            this.screens[i].isActiveInTheFlow = false;
        }
    }

    /**
     * Updates the satus of the screens based on the provided list commands
     * 
     * @param screenStatusCommands List of commands that indicates which screens should
     *                             be updated and the new status.
     **/
    private updateScreensStatusInFlow(screenStatusCommands: IScreenStatusCommand[]): void {

        // Abort in case there are no screens to update
        if (!screenStatusCommands || screenStatusCommands.length == 0) {
            return;
        }
        for (var i = 0; i < screenStatusCommands.length; i++) {
            let targetScreenIndex = screenStatusCommands[i].targetScreenIndex;
            let newVisibilityValue = screenStatusCommands[i].active;

            // Throw error in case the screen index to update is 
            // bigger than the amount of screens
            if (this.screens.length < targetScreenIndex) {
                throw `The index ${targetScreenIndex} is out of bounds. Currently there are only ${this.screens.length} screens`;
            }

            this.screens[targetScreenIndex].isActiveInTheFlow = newVisibilityValue;
        }
    }

    /**
     * Callback called when the user clicks on the button 'Previous'
     **/
    private onPrevClick(e): boolean {
        // Validate if is the first screen, can't move further back
        if (this.activeScreenIndex - 1 < 0)
            return false;

        // Move to the previous screen
        this.goToPreviousActiveScreen();

        // Prevents to fire the default action of the button
        return false;
    }

    /**
     * Moves to the next active screen. This process hides the current
     * active screen and searches for the next active screen in the line 
     * and shows it to the user
     **/
    private goToNextActiveScreen():void {
        this.getActiveScreen().hideScreen();

        for (var i = this.activeScreenIndex + 1; i < this.screens.length; i++) {
            if (this.screens[i].isActiveInTheFlow) {
                this.activeScreenIndex = i;
                break;
            }
        }
        
        this.navigationBarManager.updateNavigationBarStatus(this.activeScreenIndex, this.getActiveScreen().getNavigationBarStatus());

        this.navigationBarManager.disableNextButton();
        this.navigationBarManager.updateNextButtonTitle(Constants.NEXT_TITLE);

        this.getActiveScreen().loadScreenInitialStatus();
        this.getActiveScreen().showScreen();

        window.scroll(0, 0);
    }

    /**
     * Moves to the previous active screen. This process hides the current
     * active screen and searches for the previous active screen in the line 
     * and shows it to the user
     **/
    private goToPreviousActiveScreen(): void {
        this.getActiveScreen().hideScreen();

        for (var i = this.activeScreenIndex - 1; i >= 0; i--) {
            if (this.screens[i].isActiveInTheFlow) {
                this.activeScreenIndex = i;
                break;
            }
        }

        this.navigationBarManager.updateNavigationBarStatus(this.activeScreenIndex, this.getActiveScreen().getNavigationBarStatus());

        this.getActiveScreen().loadScreenInitialStatus();
        this.getActiveScreen().showScreen();

        window.scroll(0, 0);
    }

    /**
     * Callback called when the user clicks on the button 'Exit'
     **/
    private onExitClick(e): boolean {
        this.resetForm();
        // Prevents to fire the default action of the button
        return false;
    }

    /**
     * Callback called when the user clicks on the button 'Close app'
     **/
    private onCloseAppClick(e) {
        e.preventDefault();
        e.stopPropagation();
        this.resetForm();
        window.close();
    }

    /**
     * Restarts the form to clear all selections and start over.
     */
    private resetForm(): void {
        window.location.reload();
    }
}